import { ROLE_OBJECT_TYPE } from "@/common/enums/roleObjectType";

export const checkIsGlobalManagementPermission = (permission) => {
  return (
    permission?.objectType === ROLE_OBJECT_TYPE.MANAGEMENT &&
    permission?.objectId === "*" &&
    permission?.organizationId === null
  );
};

export const checkIsOrganizationManagementPermission = (permission) => {
  return (
    permission?.objectType === ROLE_OBJECT_TYPE.MANAGEMENT &&
    permission?.objectId === "*" &&
    permission?.organizationId !== null
  );
};
